const { getEnumManageConfig } = require('@/views/system/enum-manage/config');
const { CHANNEL_INTERFACE_TYPE } = require('@/enums');

module.exports = () => {
  return {
    type: {
      label: '渠道',
      type: 'select',
      options: getEnumManageConfig().channel_interface_options,
      value: CHANNEL_INTERFACE_TYPE.JRTT,
      rules: {
        required: true,
        trigger: ['change'],
        message: '请选择渠道',
      },
    },
    tag_id: {
      label: '标签ID',
      type: 'input',
      value: '',
      rules: {
        required: true,
        trigger: ['change'],
        message: '请输入标签ID',
      },
    },
    tag_name: {
      label: '标签名',
      type: 'input',
      value: '',
      rules: {
        required: true,
        trigger: ['change'],
        message: '请输入标签名',
      },
    },
    enum_name: {
      label: '枚举值名',
      type: 'input',
      value: '',
      rules: {
        required: true,
        trigger: ['change'],
        message: '请输入枚举值名',
      },
    },
    enum_desc: {
      label: '枚举描述',
      type: 'input',
      value: '',
      rules: {
        required: true,
        trigger: ['change'],
        message: '请输入枚举描述',
      },
    },
  };
};
